export default __webpack_public_path__ + "static/media/hfp2.7a429128.jpg";